import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSearch = (e) => {
    e.preventDefault();
    if (search.trim()) {
      navigate(`/player/${search.trim()}`);
      setSearch('');
      setMenuOpen(false);
    }
  };

  const linkClass = (path) =>
    `px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
      location.pathname === path
        ? 'bg-mc-accent/20 text-mc-accent'
        : 'text-mc-muted hover:text-mc-text hover:bg-mc-card'
    }`;

  const mobileLinkClass = (path) =>
    `block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
      location.pathname === path
        ? 'bg-mc-accent/20 text-mc-accent'
        : 'text-mc-muted hover:text-mc-text hover:bg-mc-card'
    }`;

  return (
    <nav className="bg-mc-dark border-b border-mc-border sticky top-0 z-50">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <span className="text-2xl">⛏️</span>
            <span className="mc-title text-mc-accent text-sm">OnStats</span>
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-2">
            <Link to="/" className={linkClass('/')}>Inicio</Link>
            <Link to="/rankings" className={linkClass('/rankings')}>Jugadores</Link>
            <Link to="/servers" className={linkClass('/servers')}>Servidores</Link>
            <Link to="/download" className={linkClass('/download')}>Descargar</Link>
          </div>

          {/* Desktop search */}
          <form onSubmit={handleSearch} className="hidden md:flex items-center">
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Buscar jugador..."
              className="bg-mc-darker border border-mc-border rounded-lg px-3 py-1.5 text-sm text-mc-text placeholder-mc-muted focus:outline-none focus:border-mc-accent focus:ring-1 focus:ring-mc-accent/50 w-48"
            />
          </form>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden text-mc-muted hover:text-mc-text p-2"
          >
            {menuOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden border-t border-mc-border bg-mc-dark px-4 py-3 space-y-1">
          <Link to="/" className={mobileLinkClass('/')} onClick={() => setMenuOpen(false)}>Inicio</Link>
          <Link to="/rankings" className={mobileLinkClass('/rankings')} onClick={() => setMenuOpen(false)}>Jugadores</Link>
          <Link to="/servers" className={mobileLinkClass('/servers')} onClick={() => setMenuOpen(false)}>Servidores</Link>
          <Link to="/download" className={mobileLinkClass('/download')} onClick={() => setMenuOpen(false)}>Descargar</Link>
          <form onSubmit={handleSearch} className="pt-2">
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Buscar jugador..."
              className="w-full bg-mc-darker border border-mc-border rounded-lg px-3 py-2 text-sm text-mc-text placeholder-mc-muted focus:outline-none focus:border-mc-accent"
            />
          </form>
        </div>
      )}
    </nav>
  );
}
